import { computed } from 'vue';

export default function () {
  //cuts string after defined amount of chars
  function truncate(value: string, maxLength = 60) {
    if (!value) {
      return '';
    }
    return value.length < maxLength ? value : value.substring(0, maxLength);
  }
  //cuts string after defined amount of chars but only after a word has ended
  function truncateAfterWord(value: string, maxLength = 60) {
    if (!value) {
      return '';
    }
    if (value.length < maxLength) {
      return value;
    } else {
      const subString = value.substring(0, maxLength);
      const index = subString.lastIndexOf(' ');
      return subString.substring(0, index) + ' ...';
    }
  }

  /**
   * Returns the plain text from the HTML text
   * @param value HTML text (with tags, etc.)
   * @param skippedTags Which tags whose content should be skipped. Default is empty (nothing skipped)
   * @returns The plain text
   */
  function getPlainText(value: string, skippedTags: string[] = []) {
    const doc = new DOMParser().parseFromString(value, 'text/html');

    // concat text content of child-nodes while keeping white-space (src: https://stackoverflow.com/a/59144571)
    function getTextLoop(doc: Node) {
      const texts: string[] = [];
      Array.from(doc.childNodes).forEach((node: Node) => {
        // T19509: functionality to skip the content of the tags if defined in parameter
        const shouldSkip = skippedTags.length == 0 || skippedTags.includes(doc.nodeName.toLowerCase());

        if (node.nodeType === 3 && node.textContent && !shouldSkip) {
          texts.push(node.textContent.trim());
        } else {
          texts.push(...getTextLoop(node));
        }
      });
      return texts;
    }
    return getTextLoop(doc).join(' ');
  }

  // Transforms object to query parameters
  function paramsToString(params: any) {
    return Object.entries(params)
      .map(pair => pair[0] + '=' + pair[1])
      .join('&');
  }

  return { truncate, truncateAfterWord, getPlainText, paramsToString };
}
